import { CLASS_NAME, DEFAULT_COMPONENT } from './constants';
import {
  TypographyVariant,
  WithTheme,
  bem,
  cx,
  interpolateFont,
  interpolateTextColor,
} from '@mint/core';
import { InputLabelProps } from './input-label-props';
import React from 'react';
import styled from 'styled-components';

const InputLabelComponent = React.forwardRef<any, InputLabelProps>(
  (props, ref): React.ReactElement => {
    const {
      children,
      className,
      component = DEFAULT_COMPONENT,
      dense,
      disabled,
      error,
      focused,
      shrink,
      warning,
      ...rest
    } = props;
    return React.createElement(
      component,
      {
        className: cx(
          CLASS_NAME,
          disabled && bem.disabled(CLASS_NAME),
          error && bem.error(CLASS_NAME),
          focused && bem.focused(CLASS_NAME),
          dense && bem.dense(CLASS_NAME),
          warning && bem.warning(CLASS_NAME),
          className,
        ),
        ...rest,
      },
      ref,
      children,
    );
  },
);

InputLabelComponent.displayName = 'InputLabel';

const getTypographyVariant = (props: InputLabelProps): TypographyVariant =>
  props.dense ? 'dense' : 'control';

const getLineHeight = (props: WithTheme<InputLabelProps>): number =>
  props.dense
    ? props.theme.typography.dense.lineHeight
    : props.theme.typography.control.lineHeight;

const getLineHeightCustomProperty = (
  props: WithTheme<InputLabelProps>,
): string =>
  props.dense
    ? props.theme.vars.typography.dense.lineHeight
    : props.theme.vars.typography.control.lineHeight;

const interpolateShrink = (props: WithTheme<InputLabelProps>): string => {
  if (props.shrink) {
    return `
      transform: scale(0.75) translate(0, -100%);
    `;
  } else {
    return '';
  }
};

const interpolateInputLabelColor = (
  props: WithTheme<InputLabelProps>,
): string => {
  if (props.focused) {
    return interpolateTextColor('primary')(props);
  } else {
    return interpolateTextColor('text.secondary')(props);
  }
};

export const InputLabel = styled(InputLabelComponent)`
  ${interpolateInputLabelColor}
  ${interpolateFont(getTypographyVariant)}
  line-height: ${getLineHeight};
  line-height: var(${getLineHeightCustomProperty}, ${getLineHeight});
  transform-origin: top left;
  transition: transform 100ms ease-out;
  user-select: none;
  pointer-events: none;
  ${interpolateShrink}
`;
